import AppConstants from '../../_Constants/AppConstants';

export const COLUMN_DEFINITIONS = [{
  id: 'raspiName',
  header: () => 'RasPi Name',
  cell: item => ( item.name ),
  minWidth: '200px',
  allowLineWrap: true
}, {
  id: 'location',
  header: () => 'Far Field Location',
  cell: item => ( item.location ),
  minWidth: '100px',
  allowLineWrap: true
}];

export const SORTABLE_COLUMNS = [
  {id: 'raspiName', field: 'raspiName'},
  {id: 'location', field: 'location'},
  {id: 'nearfieldlocation', field: 'nearfieldlocation'},
  {id: 'musiclocation', field: 'musiclocation'},
  {id: 'closetalklocation', field: 'closetalklocation'},
  {id: 'functionallocation', field: 'functionallocation'}
];
